import { FeberApiClient } from "../../../services/commonServices";
import { ILowerFirstCaseMetadata } from "../../AccessMediator/types";

export const moveSingleReport = async (movingInfo: ILowerFirstCaseMetadata) => {
    let response = (await FeberApiClient.post("Report/MoveSingle", { ...movingInfo }, {
        headers: {
            "Content-Type": 'multipart/form-data'
        }
    })).data
    return !!response && !!response.success
}